<template>
  <v-card class="AppCard"
          v-bind="$attrs"
  >
    <!-- @slot for card content -->
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  /*
    * All Vuetify props for Card component are usable
    * See doc : https://vuetifyjs.com/en/api/v-card/#props
    */
  name: 'AppCard',
  inheritAttrs: false,
}
</script>

<style scoped lang="scss">
.AppCard {
  padding: 16px 20px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
              0 2px 2px 0 rgba(0, 0, 0, 0.14),
              0 1px 5px 0 rgba(0, 0, 0, 0.12);
  overflow: unset;

  @media (min-width: 600px) and (max-width: 960px) {
    padding: 12px 16px;
  }
  
  @media (max-width: 600px) {
    padding: 8px 12px;
  }
}
</style>
